import { Fragment } from 'react'
import { useTheme } from '@opallabs/hooks'
import * as styles from './styles'
import { Status } from './types'
import type { StatusIndicatorProps, WithStatus } from './types'

export { Status as StatusIndicatorStatus }
export type { StatusIndicatorProps, WithStatus }

export const StatusIndicator = ({
  active = true,
  alwaysVisibleWhenActive = false,
  status = Status.Invalid,
  styleOverrides,
  theme: propTheme,
}: StatusIndicatorProps): JSX.Element => {
  const providedTheme = useTheme()

  if (!active) return <Fragment />

  const theme = propTheme ?? providedTheme

  return (
    <span
      css={[
        styles.indicator({
          alwaysVisibleWhenActive,
          status,
          theme,
        }),
        styleOverrides,
      ]}
    />
  )
}
StatusIndicator.displayName = 'Lapidary: StatusIndicator'
